import React from 'react';
import styles from './shNewModalWrapper.module.scss';
import CloseSVG from "../../public/icons/close.svg";
import LogoSloganNegativeSVG from "../../public/logo/brand-wordmark-slogan-negativ.svg";
import ShPaymentModalGoBack from "./parts/shPaymentModalGoBack";
import ReactTooltip from "react-tooltip";

const ShNewModalWrapper = (
    {
        showSide = true,
        wideSide= false,
        contentScroll = false,

        theme = "light",
        className,

        title,
        subtitle,

        children,

        footer,
        showFooterSeparator = false,

        header,

        side,
        sideClassName = '',

        backAction= null,

        onRequestClose = () => { }
    }: any
) => {

    return <div className={(!showSide ? styles.modalFullContainer : (!wideSide ? styles.modalContainer : styles.modalWideContainer)) + " w-100 " + (theme === "dark" && " bg-dark-00 ") + " " + className}>
            <ReactTooltip />
        {header ?
            <div className={styles.header + " py-3 pl-2 pl-md-3 d-flex justify-items-stretch align-items-center "  + styles.headerBG}>

                {header}

                <div className={styles.modalClose + " justify-self-end d-flex c-pointer px-2 px-md-3"}>
                    <CloseSVG onClick={onRequestClose} className={theme === "dark" ? "svg-light svg-24" : "svg-24"} />
                </div>
            </div>
        :
            <div className={styles.header + "  pt-4 px-4 d-flex justify-items-between align-items-center w-100"}>

                <div className="pl-2 w-100">
                    {backAction !== null &&
                        <ShPaymentModalGoBack action={backAction}/>
                    }
                </div>

                <div className={styles.modalClose + " d-flex c-pointer opacity-50"}>
                    <CloseSVG onClick={onRequestClose} className={theme === "dark" ? "svg-light svg-24" : "svg-24"}/>
                </div>
            </div>
        }

        <div className={(showSide ? styles.maxWidthContent : " " ) + " " + styles.content + " mx-auto w-100 px-4 " + (contentScroll && styles.contentScroll)}>
            <div className={"mb-4"}>
                {title !== "" && <h5>{title}</h5>}
                {subtitle !== "" && <p className="strong mt-1">{subtitle}</p>}
            </div>
            <div className={styles.contentChildren}>
            { children }
            </div>
        </div>

        {footer &&
        <div className={styles.footer + " mw-card mx-auto mb-4 mb-lg-5 w-100 px-4 " + (showFooterSeparator ? styles.footerSeparator : "")}>
            {footer}
        </div>
        }

        {showSide &&
            (side ?
                    <div className={styles.side + "  " + sideClassName}>
                        { side }
                    </div>

                    :
                    <div className={styles.side + " h-100 p-3 d-flex align-items-center "}>
                        <LogoSloganNegativeSVG/>
                    </div>
            )
        }

    </div>
}

export default ShNewModalWrapper;
